import { dateDayWeeksBefore } from 'utils/dates';

const dataWeakness = [
  {
    investorType: 'Venture Capital',
    weakness: 'Scale',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },
  {
    investorType: 'Venture Capital',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },

  {
    investorType: 'Venture Capital',
    weakness: 'Leverage',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Venture Capital',
    weakness: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    weakness: 'Scale',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    weakness: 'Profitability',
    count: 2,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },

  {
    investorType: 'Venture Capital',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },

  {
    investorType: 'Venture Capital',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Venture Capital',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    weakness: 'Scale',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    weakness: 'Scale',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    weakness: 'Other',
    count: 3,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Holding Company',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Holding Company',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },

  {
    investorType: 'Venture Capital',
    weakness: 'Competition',
    count: 3,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Venture Capital',
    weakness: 'Sustainability',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Venture Capital',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },

  {
    investorType: 'PE',
    weakness: 'Scale',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'PE',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'SWF',
    weakness: 'Sustainability',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },

  {
    investorType: 'Mutual Fund',
    weakness: 'Scale',
    count: 2,
    date: dateDayWeeksBefore(2, 2)
  },
  {
    investorType: 'Mutual Fund',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },

  {
    investorType: 'Venture Capital',
    weakness: 'Sustainability',
    count: 5,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'PE',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'PE',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },

  {
    investorType: 'SWF',
    weakness: 'Sustainability',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'Mutual Fund',
    weakness: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },

  {
    investorType: 'Hedge Fund',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(1, 3)
  },

  {
    investorType: 'Venture Capital',
    weakness: 'Scale',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Venture Capital',
    weakness: 'Sustainability',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Venture Capital',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    weakness: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },

  {
    investorType: 'Corporate',
    weakness: 'Profitability',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Holding Company',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },

  {
    investorType: 'Pension Fund',
    weakness: 'Competition',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Pension Fund',
    weakness: 'Other',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    weakness: 'Scale',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  }
];

export default dataWeakness;
